import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestConsentGet = {
    path: "/consent",
    method: RouteHttpVerb.GET,
    obfuscatePath: "keep-last-part"
};
export { locationRestConsentGet };
